// Hooks
import { AlbumProvider } from '@/utils/hooks/context/useAlbumContext';

import PropTypes from 'prop-types';

// Components
import FunnelModalContent from '@/components/pages/albums/AlbumFunnelModal/FunnelModalContent';

const FunnelModal = ({
    isOpen,
    toggle,
    params = {},
    variant = 'single',
    callbackUpdateAlbum = () => {
        /** */
    }
}) => {
    if (!isOpen) return null;
    return (
        <AlbumProvider params={params} mode={variant}>
            <FunnelModalContent
                isOpen={isOpen}
                toggle={toggle}
                callbackUpdateAlbum={callbackUpdateAlbum}
            />
        </AlbumProvider>
    );
};

FunnelModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    params: PropTypes.object,
    variant: PropTypes.oneOf(['single', 'group'])
};

export default FunnelModal;
